<ion-list class="recent-searches ion-no-padding">
  <h2
    class="marb10 ion-no-margin ion-margin-horizontal fs-4 font600 title-text-color"
  >
    {{ 'bus.bus_search.recent_search_title' | translate }}
  </h2>

  <swiper-container
    slides-per-view="auto"
    space-between="12"
    free-mode="true"
    class="carousel ion-no-padding ion-no-margin ion-padding-horizontal ion-margin-bottom"
  >
    <swiper-slide
      *ngFor="let item of recentSearches"
      class="search-card"
      (click)="onCardClick(item)"
    >
      <div class="badge">
        <ion-icon name="bus-outline"></ion-icon>
      </div>

      <div class="search-details">
        <div class="route">
          <div class="src-dest">
            <div
              class="origin fs-4 font600 card-primary-text-color line-1-clip"
            >
              {{ item?.source }}
            </div>
            <div class="arrow fs-4 font600 card-primary-text-color padl5">
              →
            </div>
          </div>
          <div
            class="destination fs-4 font500 card-primary-text-color mart2 line-1-clip"
          >
            {{ item?.destination }}
          </div>
        </div>
        <div class="fs-2 font400 mart2 card-secondary-text-color">
          {{ item?.departureDate }}
        </div>
      </div>
    </swiper-slide>
  </swiper-container>
</ion-list>
